import useCookieDeclaration from "hooks/useCookieDeclaration";

function CookiesDE() {
  useCookieDeclaration({ slotId: "cookie-declaration-slot-de", culture: "de" });

  return (
    <div className="hero hero__secondary position-relative bg-white px-2 px-sm-0">
      <div className="container narrow bg-white rounded-5 p-md-5">
        <div class="cook">
          <h1>Cookie-Richtlinien</h1>

          <p>
            Damit die Website ordnungsgem&auml;&szlig; funktioniert und Ihr
            Browser-Erlebnis aktualisiert und verbessert werden kann, muss eine
            minimale Menge an Informationen (Cookies) auf Ihrem Computer
            gespeichert werden. Mehr als 90 % aller Websites verwenden Cookies,
            doch sind sie nach den Regeln der Europ&auml;ischen Union dazu
            verpflichtet, die Zustimmung des Nutzers einzuholen. Durch die
            Nutzung dieser Website erkl&auml;ren Sie sich mit der Verwendung von
            Cookies einverstanden. Auch wenn Sie keine Cookies akzeptieren,
            k&ouml;nnen Sie die Website zwar besuchen, doch kann es sein, dass
            bestimmte Funktionen auf dieser Website eingeschr&auml;nkt sind.
          </p>
          <h2>Was ist ein Cookie?</h2>
          <p>
            Ein Cookie ist eine Information, die von der Website, die Sie
            besucht haben, auf Ihrem Computer gespeichert wird. Cookies
            speichern in der Regel Ihre Einstellungen f&uuml;r die Website, wie
            z.&nbsp;B. die gew&uuml;nschte Sprache oder Adresse. Sp&auml;ter,
            wenn Sie dieselbe Website erneut aufrufen, sendet der Browser
            Cookies zur&uuml;ck, die sich auf die Website beziehen. Auf diese
            Weise kann die Website Informationen anzeigen, die auf Ihre
            Bed&uuml;rfnisse zugeschnitten sind.
          </p>
          <p>
            Cookies k&ouml;nnen eine Vielzahl von Informationen speichern,
            einschlie&szlig;lich personenbezogener Daten (Ihren Namen oder Ihre
            E-Mail-Adresse). Dennoch k&ouml;nnen diese Informationen nur dann
            gespeichert werden, wenn Sie dies zulassen &ndash; ohne Ihre
            Erlaubnis k&ouml;nnen Websites weder auf Informationen noch auf
            andere Dateien auf Ihrem Computer oder Mobilger&auml;t zugreifen.
            Die Standardeinstellungen zum Speichern und Versenden von Cookies
            sind f&uuml;r Sie nicht sichtbar. Sie k&ouml;nnen Ihre
            Browsereinstellungen &auml;ndern und selbst ausw&auml;hlen, ob Sie
            das Speichern von Cookies genehmigen oder ablehnen m&ouml;chten, ob
            gespeicherte Cookies beim Schlie&szlig;en des Browsers automatisch
            gel&ouml;scht werden sollen usw.
          </p>
          <h2>Wie lehnt man Cookies ab?</h2>
          <p>
            Durch die Ablehnung von Cookies entscheiden Sie, ob Sie die
            Speicherung von Cookies auf Ihrem Computer oder Mobilger&auml;t
            zulassen m&ouml;chten. Die Cookie-Einstellungen k&ouml;nnen in Ihrem
            Browser &uuml;berpr&uuml;ft und konfiguriert werden. Wenn Sie keine
            Cookies akzeptieren, kann es vorkommen, dass Sie bestimmte
            Funktionen auf der aufgerufenen Website nicht nutzen k&ouml;nnen.
          </p>
          <h2>Was sind tempor&auml;re Cookies?</h2>
          <p>
            Tempor&auml;re oder Session-Cookies werden vom Computer
            gel&ouml;scht, sobald Sie den Browser geschlossen haben. Mit Hilfe
            dieser Cookies speichern Websites tempor&auml;re Daten, wie
            z.&nbsp;B. Produkte in einem Warenkorb.
          </p>
          <h2>Was sind dauerhafte Cookies?</h2>
          <p>
            Dauerhafte oder persistente Cookies verbleiben auch nach
            Schlie&szlig;en des Browsers auf Ihrem Computer. Mithilfe dieser
            Cookies speichern Websites Daten wie Login-Name und Passwort, so
            dass Sie sich nicht bei jedem Besuch einer bestimmten Website neu
            anmelden m&uuml;ssen. Dauerhafte Cookies bleiben mehrere Tage,
            Monate oder sogar Jahre auf Ihrem Computer.
          </p>
          <h2>Was sind First-Party-Cookies?</h2>
          <p>
            First-Party-Cookies (Cookies von Erstanbietern) stammen von der
            Website, die der Benutzer gerade besucht, und k&ouml;nnen dauerhaft
            oder tempor&auml;r sein. Mithilfe dieser Cookies k&ouml;nnen
            Websites Daten speichern, die beim n&auml;chsten Besuch der Website
            wiederverwendet werden.
          </p>
          <h2>Was sind Third-Party-Cookies?</h2>
          <p>
            Third-Party-Cookies (Cookies von Drittanbietern) sind Cookies, die
            von einer anderen Website angelegt werden, als von der, die Sie
            gerade besuchen (z.&nbsp;B. Popup-Fenster oder andere Formen von
            Werbung). Mithilfe dieser Cookies k&ouml;nnen Websites Ihre
            Internetnutzung f&uuml;r Marketingzwecke verfolgen.
          </p>
          <h2>Verwendet diese Webseite Cookies?</h2>
          <p>
            Ja, und zwar mit dem Hauptziel, Ihnen auf unserer Website das
            bestm&ouml;gliche Nutzererlebnis zu bieten.
          </p>
          <h2>Welche Cookies verwendet diese Webseite und warum?</h2>
          <p>
            Tempor&auml;re Cookies oder Sitzungs-Cookies (Session Cookies)
            &ndash; laufen ab (und werden automatisch gel&ouml;scht), wenn Sie
            den Browser schlie&szlig;en. Wir verwenden tempor&auml;re Cookies,
            um dem Nutzer die bestm&ouml;gliche Nutzung unserer Website zu
            erm&ouml;glichen.
          </p>
          <p>
            Dauerhafte oder persistente Cookies (Persistent Cookies) &ndash;
            haben in der Regel ein weit in der Zukunft liegendes Verfallsdatum,
            sodass sie so lange in Ihrem Browser bleiben, bis sie ablaufen oder
            Sie sie manuell l&ouml;schen. Wir verwenden dauerhafte Cookies, um
            die Nutzergewohnheiten besser verstehen und somit die Website nach
            Ihren Pr&auml;ferenzen verbessern zu k&ouml;nnen. Die so erhobenen
            Daten k&ouml;nnen nicht dazu verwendet werden, Sie als Nutzer zu
            identifizieren, und werden ausschlie&szlig;lich f&uuml;r
            statistische Zwecke verwendet.
          </p>
          <h2>Gibt es auf dieser Website Cookies von Drittanbietern?</h2>
          <p>
            Es gibt mehrere externe Dienste, welche die erw&auml;hnten Cookies
            f&uuml;r den Benutzer speichern. Diese Cookies wurden zwar nicht von
            dieser Website angelegt, dienen aber dazu, den normalen Betrieb
            bestimmter Funktionen zu gew&auml;hrleisten, die den Nutzern den
            Zugriff auf die Inhalte der Website erleichtern. Aus diesem Grund
            gelten die Ihnen hier zur Verf&uuml;gung gestellten
            Datenschutzinformationen nur f&uuml;r diese Website, w&auml;hrend
            der Datenschutz auf externen Serviceseiten auf den entsprechenden
            offiziellen Websites &uuml;berpr&uuml;ft werden muss.
          </p>
          <h2>Momentan erm&ouml;glichen wir:</h2>
          <h3>Messung von Website-Besuchen</h3>
          <p>
            Diese Website benutzt Dienste zur Messung der Anzahl der Nutzer,
            insbesondere Google Analytics. Die so erhobenen Daten k&ouml;nnen
            nicht dazu verwendet werden, Sie als Nutzer zu identifizieren, und
            werden ausschlie&szlig;lich f&uuml;r statistische Zwecke verwendet.
            Wenn Sie verhindern m&ouml;chten, dass diese Dienste Cookies bei
            Ihnen speichern, k&ouml;nnen Sie diese f&uuml;r jeden Dienst unter
            den folgenden Links ablehnen:
          </p>
          <ul>
            <li>
              <p>
                Google Analytics -&nbsp;
                <a href="https://tools.google.com/dlpage/gaoptout">
                  https://tools.google.com/dlpage/gaoptout
                </a>
              </p>
            </li>
          </ul>
          <h2>Weitere Informationen zur Ablehnung von Cookies</h2>
          <p>
            Es gibt derzeit mehrere Websites, um die Speicherung von Cookies
            f&uuml;r verschiedene Dienste abzulehnen.
          </p>
          <p>Mehr erfahren Sie unter den folgenden Links:</p>
          <ul>
            <li>
              <p>
                <a href="http://www.allaboutcookies.org/">
                  http://www.allaboutcookies.org
                </a>
              </p>
            </li>
            <li>
              <p>
                <a href="http://www.youronlinechoices.eu/">
                  http://www.youronlinechoices.eu/
                </a>
              </p>
            </li>
          </ul>
          <div id="cookie-declaration-slot-de" />
          {/*           <table className="CookieDeclarationTable">
            <colgroup>
              <col style={{ width: "20%" }} />
              <col style={{ width: "20%" }} />
              <col style={{ width: "35%" }} />
              <col style={{ width: "15%" }} />
              <col style={{ width: "10%" }} />
            </colgroup>
            <thead>
              <tr>
                <th
                  scope="col"
                  className="CookieDeclarationTableHeader"
                  dir="ltr">
                  Name
                </th>
                <th
                  scope="col"
                  className="CookieDeclarationTableHeader"
                  dir="ltr">
                  Anbieter
                </th>
                <th
                  scope="col"
                  className="CookieDeclarationTableHeader"
                  dir="ltr">
                  Zweck
                </th>
                <th
                  scope="col"
                  className="CookieDeclarationTableHeader"
                  dir="ltr">
                  Maximale Speicherdauer
                </th>
                <th
                  scope="col"
                  className="CookieDeclarationTableHeader"
                  dir="ltr">
                  Typ
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="CookieDeclarationTableCell">
                  CookieConsent [x2]
                </td>
                <td className="CookieDeclarationTableCell">
                  sgtm.argeta.com
                  <br />
                  <a
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    href="https://www.cookiebot.com/goto/privacy-policy/"
                    title="Politika zasebnosti za Cookiebot">
                    Cookiebot
                  </a>
                </td>
                <td className="CookieDeclarationTableCell">
                  Stores the user&apos;s cookie consent state for the current
                  domain
                </td>
                <td className="CookieDeclarationTableCell">1 year</td>
                <td className="CookieDeclarationTableCell">HTTP cookie</td>
              </tr>
              <tr>
                <td className="CookieDeclarationTableCell">test_cookie</td>
                <td className="CookieDeclarationTableCell">
                  <a
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    href="https://business.safety.google/privacy/"
                    title="Politika zasebnosti za Google">
                    Google
                  </a>
                </td>
                <td className="CookieDeclarationTableCell">
                  Used to check if the user&apos;s browser supports cookies.
                </td>
                <td className="CookieDeclarationTableCell">1 day</td>
                <td className="CookieDeclarationTableCell">HTTP cookie</td>
              </tr>
            </tbody>
          </table> */}
        </div>
      </div>
    </div>
  );
}

export default CookiesDE;
